/*
Parses Routes to set initial state for application;
*/
class RouteParams {
  constructor({ selectedProject = null, currentModule = null, currentModuleFilter = null, subModule1 = null, subModule1Filter = null }) {
    this.selectedProject = selectedProject;
    this.currentModule = currentModule;
    this.currentModuleFilter = currentModuleFilter;
    this.subModule1 = subModule1;
    this.subModule1Filter = subModule1Filter;
  }
}

function parseLocation(loc) {
  const regex = new RegExp('([^/]+)', 'gm');
  const parts = loc.match(regex);
  if (parts != null) {
    // even index are modules
    const modules = parts.filter((a, i) => i % 2 === 0);
    // odd indexes are filters
    const filters = parts.filter((a, i) => i % 2 !== 0);

    const getItem = (arr, index) => arr[index] ? arr[index] : null;

    const params = {
      selectedProject: getItem(filters, 0),
      // skip the first index of modules bc its always projects
      currentModule: getItem(modules, 1),
      currentModuleFilter: getItem(filters, 1),
      subModule1: getItem(modules, 2),
      subModule1Filter: getItem(filters, 2)
    }
    return new RouteParams(params);
  } else {
    return new RouteParams({});
  };
};


/*const routes = {
  "/projects": {},
  "/projects/:projectId/overview": {},
  "/projects/:projectId/dashboard": {},
  "/projects/:projectId/details": {},
  "/projects/:projectId/inspections": {},
  "/projects/:projectId/contacts": {},
  "/projects/:projectId/contracts": {},
  "/projects/:projectId/workitems": {},
  "/projects/:projectId/resources": {},
  "/projects/:projectId/contractors": {},
  "/projects/:projectId/comments": {},
  "/projects/:projectId/fieldforms": {},
  "/projects/:projectId/samples": {},
  "/projects/:projectId/samples/:sampleid": {},
  "/projects/:projectId/documents": {},
  "/projects/:projectId/configuration": {}
}*/

export { RouteParams, parseLocation };